import { Message } from '../pages/CallsScreen'

export interface EmergencyStage {
  id: 'detect' | 'alert' | 'live'
  label: string
  detail: string
}

export const emergencyStages: EmergencyStage[] = [
  { id: 'detect', label: 'Detect', detail: 'Understands urgency mid-call' },
  { id: 'alert', label: 'Alert', detail: 'Notifies you immediately' },
  { id: 'live', label: 'Live', detail: 'Shows the ongoing conversation' },
]

/** What was already said before the emergency call is opened. */
const preamble: Message[] = [
  {
    sender: 'ai',
    text: "Hello, you've reached Jack's assistant. How can I help you?",
    time: '2:30 PM',
  },
  {
    sender: 'user',
    text: "It's Mom. I'm at the hospital with your father — I need to reach Jack urgently.",
    time: '2:30 PM',
  },
  {
    sender: 'ai',
    text: 'I understand this is urgent. Is anyone in immediate danger right now?',
    time: '2:31 PM',
  },
  {
    sender: 'user',
    text: "He's with a doctor now, but I really need Jack here.",
    time: '2:31 PM',
  },
]

/** The part that streams in live while the user watches. */
const live: Message[] = [
  {
    sender: 'ai',
    text: 'Please hold on and stay on the line — I’m trying to reach Jack right now.',
    time: '2:31 PM',
  },
  {
    sender: 'ai',
    text: 'I’ve just sent Jack a notification flagged as an urgent emergency.',
    time: '2:32 PM',
  },
  {
    sender: 'user',
    text: 'Please tell him we’re at St. Mary’s, third floor.',
    time: '2:32 PM',
  },
  {
    sender: 'ai',
    text: 'Noted — St. Mary’s, third floor. I’m staying on the line with you while I reach him.',
    time: '2:32 PM',
  },
]

/**
 * The owner reads the live transcript and directs the agent without joining
 * the call. Vexu relays it to the caller and closes the conversation.
 */
export const momLiveCommand = {
  text: 'Tell her I’m leaving now and will be at St. Mary’s in 20 minutes.',
  ack: 'Understood — I’ll let her know right away.',
  spoken: [
    {
      sender: 'ai' as const,
      text: 'I’ve just heard from Jack. He’s leaving now and will be at St. Mary’s in about 20 minutes.',
      time: '2:33 PM',
    },
    {
      sender: 'user' as const,
      text: 'Oh thank goodness. Thank you.',
      time: '2:33 PM',
    },
    {
      sender: 'ai' as const,
      text: 'Of course. I’ll let him know you’re on the third floor, and I’ll send him everything from this call. Take care.',
      time: '2:33 PM',
    },
  ],
}

export const momEmergencyScript = {
  preamble,
  live,
  summary:
    'Emergency reported by Mom: she is at St. Mary’s hospital with your father and needs you urgently. Vexu flagged the call as an emergency, kept her on the line, and sent you an urgent alert. You replied from the live call, and Vexu told her you are on your way and will arrive in about 20 minutes.',
}
